import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.loading"],
  loading => loading
);
